import { findOpenNeighbors } from '../lib/openPuzzles';

interface Props {
  /** Offene Spieltage, aufsteigend (siehe useOpenPuzzles). */
  dates: string[];
  error: string | null;
  currentDate: string;
  onJump(date: string): void;
}

/**
 * Springt direkt zum vorherigen/nächsten Tag, den man noch nachholen
 * kann (kein eigener Eintrag, Hinweise + Lösung vorhanden) — statt sich
 * mit den Tages-Pfeilen durch lauter erledigte Tage zu klicken. Die Buttons zeigen das Ziel-Datum, damit klar ist, wie weit
 * der Sprung geht. Ohne Sprungziel bleibt die Leiste ausgeblendet.
 */
export function OpenPuzzleNav({ dates, error, currentDate, onJump }: Props) {
  if (error) return <p className="open-nav__error">{error}</p>;
  const { prev, next, position } = findOpenNeighbors(dates, currentDate);
  if (!prev && !next) return null;

  const refYear = currentDate.slice(0, 4);
  const count = position != null
    ? `${position} von ${dates.length} offen`
    : `${dates.length} offen`;

  return (
    <nav className="open-nav" aria-label="Offene Rätsel zum Nachholen">
      <button
        type="button"
        className="open-nav__btn"
        disabled={!prev}
        onClick={() => prev && onJump(prev)}
        aria-label={prev ? `Vorheriges offenes Rätsel: ${longDate(prev)}` : 'Kein früheres offenes Rätsel'}
      >
        ‹ {prev ? shortDate(prev, refYear) : '—'}
      </button>
      <span className="open-nav__count">{count}</span>
      <button
        type="button"
        className="open-nav__btn"
        disabled={!next}
        onClick={() => next && onJump(next)}
        aria-label={next ? `Nächstes offenes Rätsel: ${longDate(next)}` : 'Kein späteres offenes Rätsel'}
      >
        {next ? shortDate(next, refYear) : '—'} ›
      </button>
    </nav>
  );
}

/** "24.09." im selben Jahr wie der angezeigte Tag, sonst "02.06.25". */
function shortDate(iso: string, refYear: string): string {
  const [year, month, day] = iso.split('-');
  return year === refYear ? `${day}.${month}.` : `${day}.${month}.${year?.slice(2)}`;
}

function longDate(iso: string): string {
  return new Date(`${iso}T12:00:00Z`).toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}
